import { connect } from "react-redux";
import VariantNew from "pages/secure/facility/productNew/Variant";
import { bindActionCreators, AnyAction , Dispatch } from "redux";
import * as UIActions from "redux/actions/ui";

const mapStateToProps = (state: any) => {
  const { authStore, facilityStore } = state;
  return {
    authStore: { ...authStore },
    facilityStore: { ...facilityStore },
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VariantNew);
